import update from 'immutability-helper'
import { useCallback, useState } from 'react'
import { DraggableItem } from './DraggableItem.js'
import UserService from '../../services/UserService.js'

export const DraggableContainer = (props) => {
    {
        const [cards, setCards] = useState(props.items ?? []);
        
        const moveCard = useCallback((dragIndex, hoverIndex) => {
            setCards((prevCards) => {
                const updatedCards = update(prevCards, {
                    $splice: [
                        [dragIndex, 1],
                        [hoverIndex, 0, prevCards[dragIndex]],
                    ],
                });
                let cardIdsString = updatedCards.map(card => card.id).join(',');
                UserService.updateDashboardConfiguration(props.type, cardIdsString);
                return updatedCards;
            });
        }, [])

        const renderCard = useCallback((card, index) => {
            return (
                <DraggableItem                    
                    key={card.id}
                    index={index}
                    id={card.id}
                    type={card.type}
                    content={card.content}
                    moveCard={moveCard}
                />
            )
        }, [])
        return (
            <>
                <div className={props.styleClass}>{cards.map((card, i) => renderCard(card, i))}</div>
            </>
        )
    }
}
